/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatTypeEnum } from './chatTypeEnum';


export interface ChatDto { 
    /**
     * имя чата
     */
    chatName: string;
    /**
     * описание чата
     */
    chatDescription?: string | null;
    /**
     * Признак, что контент могут создавать только Админы
     */
    onlyForAdmins?: boolean;
    chatType: ChatTypeEnum;
    /**
     * Идентификатор сторонней сущности, например, id-комитета или id-организации
     */
    attachId?: string | null;
    /**
     * Наименование объекта из AttachId
     */
    attachObjectName?: string | null;
}
export namespace ChatDto {
}


